import { useQuery } from '@tanstack/react-query';
import { fetchCurrencyListApi } from 'apis/common/commonApis';
import { fetchStoryApi } from 'apis/common/fetchDropApi';
import { soundApi } from 'apis/platform/soundApis';
import { fetchDropEpisode } from 'apis/story/episodeApis';
/**
 * * 작품 수정에 필요한 드롭다운 데이터 리스트`
 */

// 써클 이미지
export const useCircleImgDropList = (projectId: number | string) => {
  return useQuery(
    ['circleImgDropList', projectId],
    async () => await fetchStoryApi.coinBannerImgList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};

// 카테고리 썸네일
export const useCategoryImgDropList = (projectId: number | string) => {
  return useQuery(
    ['categoryImgDropList', projectId],
    async () => await fetchStoryApi.categoryImgList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};
// 배너 이미지
export const useIfyouBannerImgDropList = (projectId: number | string) => {
  return useQuery(
    ['bannerImgDropList', projectId],
    async () => await fetchStoryApi.bannerImgList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};
// 레디 이미지
export const useReadyImgDropList = (projectId: number | string) => {
  return useQuery(
    ['readyImgDropList', projectId],
    async () => await fetchStoryApi.readyImgList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};
// 종료(엔딩) 이미지
export const useEndingImgDropList = (projectId: number | string) => {
  return useQuery(
    ['endingImgDropList', projectId],
    async () => await fetchStoryApi.endingImgList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};
// 프리미엄 & 소개 이미지
export const usePremiumImgDropList = (projectId: number | string) => {
  return useQuery(
    ['premiumImgDropList', projectId],
    async () => await fetchStoryApi.premiumImgList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};

// 코인샵 배너 이미지
export const useCoinBannerImgDropList = (projectId: number | string) => {
  return useQuery(
    ['coinBannerImgDropList', projectId],
    async () => await fetchStoryApi.coinBannerImgList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};
// 작품 소개 이미지
export const useIntroduceImgDropList = (projectId: number | string) => {
  return useQuery(
    ['introduceImgDropList', projectId],
    () => fetchStoryApi.introduceImgList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};
// 장르
export const useGenreDropList = () => {
  return useQuery(
    ['genreDropList'],
    async () => await fetchStoryApi.genreList(),
  );
};
// 옵션 태그 (해시태그)
export const useHashTagDropList = (word: string) => {
  return useQuery(
    ['hashTagDropList', word],
    async () => await fetchStoryApi.hashTagList(word),
    { enabled: !!word },
  );
};

// 말풍선 세트
export const useBubbleSetDropList = () => {
  return useQuery(
    ['bubbleSetDropList'],
    async () => await fetchStoryApi.bubbleSetList(),
  );
};

// 로비 및 플레이 팝업 BGM
export const useBgmDropList = (projectId: number | string) => {
  return useQuery(
    ['bgmDropList', projectId],
    async () => await soundApi.bgmDropList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};

// 타이틀 CG
export const useTitleCgDropList = (projectId: number | string) => {
  return useQuery(
    ['titleCgDropList', projectId],
    () => fetchStoryApi.titleCgImgList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};

// 에피소드 수정 > 팝업 썸네일
export const usePopThumbnailImgDropList = (projectId: string) => {
  return useQuery(
    ['popThumbnailDropList', projectId],
    () => fetchDropEpisode.episodePopThumbnail(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};

// 잠금 해제 방식
export const useUnLockDropList = () => {
  return useQuery(['unLockDropList'], () => fetchDropEpisode.unLockList());
};

// 잠금 해제 에피소드 ID 리스트
export const useUnLockEpisodeDropList = (projectId: string) => {
  return useQuery(
    ['unLockEpisodeDropList', projectId],
    () => fetchDropEpisode.episodeUnlockList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};
// 잠금 해제 사건 ID 리스트
export const useUnLockSceneDropList = (projectId: string) => {
  return useQuery(
    ['unLockSceneDropList', projectId],
    () => fetchDropEpisode.sceneIdList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};
// 잠금 해제 쿠폰 리스트
export const useUnLockCouponDropList = (projectId: string) => {
  return useQuery(
    ['unLockCouponDropList', projectId],
    () => fetchDropEpisode.couponList(projectId),
    { enabled: !!projectId }, // 쿼리가 projectId가 있을 때만 실행한다
  );
};
